import type { EditAreaAdminState } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

export const useEditAreaQueryCache = (productId: string) => {
  const utils = trpc.useUtils();
  return {
    cancelQuery: () => utils.editor.editAreas.getLatest.cancel({ productId }),
    setQuery: (state: EditAreaAdminState) =>
      utils.editor.editAreas.getLatest.setData({ productId }, state),
    fetchState: () => utils.editor.editAreas.getLatest.fetch({ productId }, { staleTime: 0 }),
  };
};
